import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function exportExcelBranchWise({ apiData, fileName }) {
    try {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Other Deposits Report', {
            views: [{ state: 'frozen', xSplit: 1, ySplit: 3 }],
        });

        const productNames = [];
        apiData.forEach(branch => {
            branch.productSummaryDtoList?.forEach(product => {
                const trimmedName = product.productName.trim();
                if (!productNames.includes(trimmedName)) {
                    productNames.push(trimmedName);
                }
            });
        });

        const grandTotals = {};
        productNames.forEach(productName => {
            grandTotals[productName] = { count: 0, amount: 0 };
        });

        apiData.forEach(branch => {
            branch.productSummaryDtoList?.forEach(product => {
                const trimmedName = product.productName.trim();
                grandTotals[trimmedName].count += product.count || 0;
                grandTotals[trimmedName].amount += product.amount || 0;
            });
        });

        const columns = [{ header: '', key: 'product', width: 20 }];
        apiData.forEach(branch => {
            columns.push(
                { header: '', key: `${branch.branchName}_count`, width: 18 },
                { header: '', key: `${branch.branchName}_amount`, width: 18 }
            );
        });
        columns.push(
            { header: '', key: 'grandTotal_count', width: 18 },
            { header: '', key: 'grandTotal_amount', width: 18 }
        );
        sheet.columns = columns;

        // ---- TITLE ----
        const titleRow = sheet.getRow(1);
        titleRow.values = ['Other Deposits Report'];
        sheet.mergeCells(1, 1, 1, columns.length);
        titleRow.height = 25;
        titleRow.getCell(1).style = {
            font: { bold: true, size: 16 },
            alignment: { vertical: 'middle', horizontal: 'center' },
        };

        // ---- GAP ROW ---- (row 2)
        sheet.getRow(2).height = 15;

        // ---- BRANCH NAMES ---- (row 3)
        const branchRow = sheet.getRow(3);
        const branchNames = [''];
        apiData.forEach(branch => {
            branchNames.push(branch.branchName, '');
        });
        branchNames.push('GRAND TOTAL', '');
        branchRow.values = branchNames;
        branchRow.height = 20;

        let colIndex = 2;
        apiData.forEach(() => {
            sheet.mergeCells(3, colIndex, 3, colIndex + 1);
            colIndex += 2;
        });
        sheet.mergeCells(3, colIndex, 3, colIndex + 1);

        // **Branch names SHOULD be bold**
        branchRow.eachCell((cell, colNumber) => {
            if (colNumber > 1) {
                cell.style = {
                    font: { bold: true },
                    alignment: { vertical: 'middle', horizontal: 'center' },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                    }
                };
            }
        });

        // ---- COLUMN HEADERS ---- (row 4)
        const headerRow = sheet.getRow(4);
        const headers = ['Product'];
        apiData.forEach(() => {
            headers.push('No of Account', 'Amount');
        });
        headers.push('No of Account', 'Amount');
        headerRow.values = headers;
        headerRow.height = 18;

        // Column headers - **NOT BOLD**
        headerRow.eachCell(cell => {
            cell.style = {
                alignment: { vertical: 'middle', horizontal: 'center' },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                }
            };
        });

        // ---- PRODUCT DATA ROWS ----
        productNames.forEach(productName => {
            const rowData = { product: productName };

            apiData.forEach(branch => {
                const product = branch.productSummaryDtoList?.find(
                    p => p.productName.trim() === productName
                );
                rowData[`${branch.branchName}_count`] = product?.count || '';
                rowData[`${branch.branchName}_amount`] = product?.amount || '';
            });

            rowData['grandTotal_count'] = grandTotals[productName].count;
            rowData['grandTotal_amount'] = grandTotals[productName].amount;

            const row = sheet.addRow(rowData);
            row.height = 18;

            // **Data rows - NOT bold**
            row.eachCell((cell, colNumber) => {
                cell.style = {
                    alignment: { vertical: 'middle', horizontal: colNumber === 1 ? 'left' : 'right' },
                    border: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                    }
                };
            });
        });

        // ---- GRAND TOTAL ROW ---- (NO BOLD)
        const grandTotalRow = sheet.addRow(['GRAND TOTAL']);
        grandTotalRow.height = 20;

        let totalColIndex2 = 2;
        apiData.forEach(branch => {
            let branchCountTotal = 0, branchAmountTotal = 0;
            branch.productSummaryDtoList?.forEach(product => {
                branchCountTotal += product.count || 0;
                branchAmountTotal += product.amount || 0;
            });

            grandTotalRow.getCell(totalColIndex2).value = branchCountTotal;
            grandTotalRow.getCell(totalColIndex2 + 1).value = branchAmountTotal;
            totalColIndex2 += 2;
        });

        let overallCountTotal = 0, overallAmountTotal = 0;
        Object.values(grandTotals).forEach(totals => {
            overallCountTotal += totals.count;
            overallAmountTotal += totals.amount;
        });

        grandTotalRow.getCell(totalColIndex2).value = overallCountTotal;
        grandTotalRow.getCell(totalColIndex2 + 1).value = overallAmountTotal;

        // **Remove bold from the entire total row**
        grandTotalRow.eachCell((cell, colNumber) => {
            cell.style = {
                alignment: { vertical: 'middle', horizontal: colNumber === 1 ? 'left' : 'right' },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                }
            };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName);
    } catch (error) {
        console.error('Excel generation failed:', error);
        throw error;
    }
}
